import InvoiceJournalApi from '../InvoiceJournalApi';
import * as types from './ActionTypes';

function getInvoiceJournalListSuccess(result: any) {
    return { type: types.GET_INVOICE_JOURNAL_LIST, result: result };
}

export function getInvoiceJournalList() {
    return (dispatch: (result: any) => void) =>
        InvoiceJournalApi.getInvoiceJournalList().then((result: any) => {
            dispatch(getInvoiceJournalListSuccess(result));
        });
}

function getInvoiceJournalSuccess(result: any) {
    return { type: types.GET_INVOICE_JOURNAL, result: result };
}

export function getInvoiceJournal(id: number) {
    return (dispatch: (result: any) => void) =>
        InvoiceJournalApi.getInvoiceJournal(id).then((result: any) => {
            dispatch(getInvoiceJournalSuccess(result));
        });
}

function createInvoiceJournalSuccess(result: any) {
    return { type: types.CREATE_INVOICE_JOURNAL, result: result };
}

export function createInvoiceJournal(legalEntityId: number, site: number, createForeign: boolean) {
    return (dispatch: (result: any) => void) =>
        InvoiceJournalApi.createInvoiceJournal(legalEntityId, site, createForeign).then(
            (result: any) => {
                result.legalEntityId = legalEntityId;
                result.site = site;
                dispatch(createInvoiceJournalSuccess(result));
            }
        );
}
